import { Button, Card } from 'antd';
import { useTranslation } from '../../../i18n/i18n';
import { CardTitle } from './CardDataDisplay';
import TextArea from 'antd/es/input/TextArea';
import './CommentsCard.scss';
import { useEffect, useState } from 'react';

interface CommentsCardProps {
  comment: string;
  onSave: (comment: string) => Promise<void>;
}

const CommentsCard = ({ comment, onSave }: CommentsCardProps) => {
  const { t } = useTranslation('installation-location', {
    keyPrefix: 'installationLocationDetail.installation.summary.comments',
  });
  const [value, setValue] = useState(comment);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(comment);
  }, [comment]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(value);
    } catch {
      // error message already shown by the caller
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <CardTitle title={t('title')} />
      <div className={'Comments'}>
        <TextArea placeholder={t('placeholder')} value={value} onChange={(e) => setValue(e.target.value)} />
        <Button type={'primary'} loading={saving} onClick={handleSave} className={'Comments_button'}>
          {t('save')}
        </Button>
      </div>
    </Card>
  );
};

export default CommentsCard;
